const formatUserSpacesToState = (userSpace) => {
  const { id, avatar, code, name, isStaffOnly } = userSpace;

  return {
    id,
    avatar,
    code,
    name,
    isEducator: userSpace.role === 'educator',
    isStaffOnly,
  };
};

export default formatUserSpacesToState;
